<template>
  <article class="container-fluid">
    <section
      class="col-sm-12 col-md-10 col-lg-6 offset-md-1 offset-lg-3 wrapper"
    >
      <div v-if="showBackButton">
        <back-button />
      </div>
      <section class="d-flex flex-column">
        <h1 class="heading-title">
          {{ $t('ONBOARDING.INSTITUTION_REQUEST.HEADING_1') }}
        </h1>
        <div class="class-info-container">
          <p class="description">
            {{ $t('ONBOARDING.INSTITUTION_REQUEST.DESCRIPTION_1') }}
          </p>
          <p class="description">
            {{ $t('ONBOARDING.INSTITUTION_REQUEST.DESCRIPTION_2') }}
          </p>
          <p class="description">
            {{ $t('ONBOARDING.INSTITUTION_REQUEST.DESCRIPTION_3') }}
          </p>
          <p class="description">
            {{ $t('ONBOARDING.INSTITUTION_REQUEST.DESCRIPTION_4') }}
          </p>
          <div
            v-if="
              userData &&
              userData.role != 'student' &&
              userData.role != 'parent' &&
              userData.launchType !== 'lti'
            "
            class="logged-in-container"
          >
            <div class="login-desc-1">
              {{ $t('ONBOARDING.INSTITUTION_REQUEST.DESCRIPTION_7') }}
            </div>
            <div class="login-desc-2">
              {{ $t('ONBOARDING.INSTITUTION_REQUEST.DESCRIPTION_8') }}
            </div>
            <a
              href="javascript:void(0)"
              class="btn btn-inst btn-main-1 setup-btn"
              qid="instiReq-2"
              @click="navigateToDashboardApp(['teacher', 'setupschool'])"
            >
              {{ $t('ONBOARDING.INSTITUTION_REQUEST.INSTI_BTN_ACCOUNT') }}
            </a>
            <div class="login-desc-3">
              {{ $t('ONBOARDING.INSTITUTION_REQUEST.DESCRIPTION_6') }}
            </div>
          </div>
          <div v-else-if="userData == false" class="not-logged-in-container">
            <div class="not-login-desc-1">
              {{ $t('ONBOARDING.INSTITUTION_REQUEST.DESCRIPTION_5') }}
            </div>
            <NuxtLink
              to="/register-teacher"
              class="btn btn-inst btn-main-1 signup-btn"
              qid="instiReq-1"
            >
              {{ $t('ONBOARDING.INSTITUTION_REQUEST.INSTI_BTN_SIGN') }}
            </NuxtLink>
            <div class="not-login-desc-2">
              {{ $t('ONBOARDING.INSTITUTION_REQUEST.DESCRIPTION_6') }}
            </div>
          </div>
          <h2 id="compareTableHeading" class="sub-heading mt-4">
            {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_TABLE_HEADING') }}
          </h2>
          <div class="table-container mb-1 mt-4">
            <div class="table-inner-container">
              <div class="table-cell-container">
                <table aria-describedby="compareTableHeading">
                  <tr>
                    <th class="subheading-1">
                      {{
                        $t('ONBOARDING.INSTITUTION_REQUEST.COLUMN_HEADING_1')
                      }}
                    </th>
                    <th class="subheading-2">
                      {{
                        $t('ONBOARDING.INSTITUTION_REQUEST.COLUMN_HEADING_2')
                      }}
                    </th>
                  </tr>
                  <tr>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_1') }}
                    </td>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_1') }}
                    </td>
                  </tr>
                  <tr>
                    <td class="hyphen">-</td>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_2') }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_3') }}
                    </td>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_3') }}
                    </td>
                  </tr>
                  <tr>
                    <td class="hyphen">-</td>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_4') }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_5') }}
                    </td>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_5') }}
                    </td>
                  </tr>
                  <tr>
                    <td class="hyphen">-</td>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_6') }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_7') }}
                    </td>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_8') }}
                    </td>
                  </tr>
                  <tr>
                    <td class="hyphen">-</td>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_9') }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_10') }}
                    </td>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_10') }}
                    </td>
                  </tr>
                  <tr>
                    <td class="hyphen">-</td>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_11') }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_12') }}
                    </td>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_12') }}
                    </td>
                  </tr>
                  <tr>
                    <td class="hyphen">-</td>
                    <td>
                      {{ $t('ONBOARDING.INSTITUTION_REQUEST.COMPARE_13') }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="quiz-container">
          <div class="quiz-heading">
            {{ $t('ONBOARDING.INSTITUTION_REQUEST.START_QUIZ_HEADING') }}
          </div>
          <div class="quiz-description">
            {{ $t('ONBOARDING.INSTITUTION_REQUEST.START_QUIZ_DESCRIPTION') }}
          </div>
          <button
            class="btn btn-main-color-1-bordered quiz-button"
            data-bs-toggle="modal"
            data-bs-target="#inst-quiz-modal"
            href="javascript:void(0)"
          >
            <span class="quiz-text">{{
              $t('ONBOARDING.INSTITUTION_REQUEST.START_QUIZ')
            }}</span>
            <ClientOnly>
              <nuxt-icon
                loading="lazy"
                name="arrow-right-purple"
                class="quiz-right-icon"
                aria-hidden="true"
              />
            </ClientOnly>
          </button>
        </div>
        <div class="class-info-container">
          <div
            v-if="
              userData &&
              userData.role != 'student' &&
              userData.role != 'parent' &&
              userData.launchType !== 'lti'
            "
            class="logged-in-container"
          >
            <div class="login-desc-1">
              {{ $t('ONBOARDING.INSTITUTION_REQUEST.DESCRIPTION_7') }}
            </div>
            <div class="login-desc-2">
              {{ $t('ONBOARDING.INSTITUTION_REQUEST.DESCRIPTION_8') }}
            </div>
            <a
              href="javascript:void(0)"
              class="btn btn-inst btn-main-1 setup-btn"
              qid="instiReq-4"
              @click="navigateToDashboardApp(['teacher', 'setupschool'])"
            >
              {{ $t('ONBOARDING.INSTITUTION_REQUEST.INSTI_BTN_ACCOUNT') }}
            </a>
          </div>
          <div v-else-if="userData == false" class="not-logged-in-container">
            <div class="not-login-desc-1">
              {{ $t('ONBOARDING.INSTITUTION_REQUEST.DESCRIPTION_5') }}
            </div>
            <NuxtLink
              to="/register-teacher"
              class="btn btn-inst btn-main-1 signup-btn"
              qid="instiReq-3"
            >
              {{ $t('ONBOARDING.INSTITUTION_REQUEST.INSTI_BTN_SIGN') }}
            </NuxtLink>
          </div>
        </div>
      </section>

      <!-- Quiz Modal -->
      <InstitutionQuizModal />
    </section>
  </article>
</template>

<script setup>
const { hideLoader } = useLoaderService();
const route = useRoute();
const { addQueryParams } = useHttpHelper();
let queryParams = route.query;
const userData = ref(null);
const { getUserData, checkUserAuthenticatedCache } = useOnboardingAuth();
const { navigateToDashboardApp } = useInterAppNavigationService();
const { t } = useI18n();
queryParams = {
  ...queryParams,
  rurl: encodeURIComponent('/dashboard/teacher/setupschool')
};
const allowedQueryParams = [
  ...useRuntimeConfig().public.ielts.allowedQueryParams,
  'rurl'
];

const props = defineProps({
  showBackButton: {
    type: Boolean,
    default: false
  }
});

definePageMeta({
  layout: 'info-layout',
  middleware: ['common-loader']
});
useHead({
  title: t(`ONBOARDING.HTML_META.INSTITUTION_REQUEST.TITLE`)
});
if (process.client) {
  usePageTitle().setPageTitle(
    t(`ONBOARDING.HTML_META.INSTITUTION_REQUEST.TITLE`)
  );
}
onBeforeMount(() => {
  hideLoader();
  checkUserAuthenticatedCache().then((resp) => {
    if (resp) {
      userData.value = getUserData();
    } else userData.value = false;
  });
});

onBeforeUnmount(() => {
  usePageTitle().setPageTitle('');
});
</script>

<style lang="scss" scoped>
@import '../assets/scss/helper.scss';

.container-fluid {
  padding: 0 30px;

  .wrapper {
    padding-top: 32px;
    padding-bottom: 32px;

    h1,
    h2,
    p {
      color: var(--cup-general-color-5);
    }

    hr {
      width: 100%;
      background-color: var(--cup-general-color-3);
    }

    .last-updated {
      color: var(--cup-general-color-4);
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
    }

    .cambridge-one-platform {
      font-size: 21px;
      font-weight: 800;
      line-height: 32px;
    }

    .heading-title {
      font-size: 48px;
      font-weight: 400;
      line-height: 60px;
      padding-top: 8px;
      padding-bottom: 24px;
      margin-bottom: 0;
      text-align: center;
      letter-spacing: -1px;
      @include media-breakpoint-down(sm) {
        font-size: 24px;
        line-height: 30px;
        font-weight: 700;
        letter-spacing: normal;
      }
    }

    .info-text {
      color: var(--cup-general-color-4);
      font-size: 16px;
      font-weight: bold;
      line-height: 24px;
      padding-bottom: 23px;
      padding-top: 17px;
      text-align: center;
    }

    .description {
      padding-bottom: 8px;
      font-size: 18px;
      line-height: 28px;
      color: var(--cup-general-color-5);
      @include media-breakpoint-down(sm) {
        font-size: 16px;
        line-height: 24px;
      }
    }

    .class-info-container {
      padding-left: 30px;
      padding-right: 30px;
      @include media-breakpoint-down(sm) {
        padding-left: 0;
        padding-right: 0;
      }
    }

    .not-logged-in-container,
    .logged-in-container {
      text-align: center;
      padding-top: 8px;
      padding-bottom: 8px;
    }

    .not-login-desc-1 {
      font-size: 18px;
      line-height: 28px;
      font-weight: 700;
      text-align: center;
      padding-top: 16px;
      @include media-breakpoint-down(sm) {
        font-size: 14px;
        line-height: 20px;
        padding-left: 16px;
        padding-right: 16px;
      }
    }

    .login-desc-1,
    .login-desc-2 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 700;
      text-align: left;
      padding-top: 16px;
      @include media-breakpoint-down(sm) {
        font-size: 12px;
        line-height: 18px;
        padding-left: 16px;
        padding-right: 16px;
      }
    }

    .not-login-desc-2,
    .login-desc-3 {
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
      text-align: center;
      padding-top: 8px;
      padding-bottom: 12px;
      @include media-breakpoint-down(sm) {
        font-size: 14px;
        line-height: 20px;
      }
    }

    .login-desc-3 {
      @include media-breakpoint-down(sm) {
        display: none;
      }
    }

    .btn-inst {
      border-radius: 30px;
      padding: 16px 20px;
      font-size: 14px;
      line-height: 16px;
      margin: 24px auto;
    }

    .setup-btn {
      @include media-breakpoint-down(sm) {
        width: calc(100% - 32px);
      }
    }

    .sub-heading {
      text-align: left;
      font-size: 30px;
      line-height: 38px;
      font-weight: 400;
      @include media-breakpoint-down(sm) {
        font-size: 24px;
        line-height: 32px;
      }
      @include media-breakpoint-down(md) {
        text-align: center;
      }
    }

    .table-container {
      width: 100%;
      font-size: 14px;
      line-height: 20px;
      .table-inner-container {
        display: table;
        table-layout: fixed;
        width: 100%;
        .table-cell-container {
          display: table-cell;
          width: 100%;
          table {
            border: 1px solid var(--cup-general-color-3);
            width: 100%;
            border-collapse: collapse;
            tr {
              th {
                font-weight: 700;
                padding: 15px;
                border: 1px solid var(--cup-general-color-3);
                color: var(--cup-main-color-1);
                &.subheading-1 {
                  border-right: none;
                }
                &.subheading-2 {
                  border-left: none;
                }
              }
              td {
                font-weight: 400;
                vertical-align: top;
                padding: 10px 10px 10px 15px;
                border-left: 1px solid var(--cup-general-color-3);
                &.hyphen {
                  padding-left: 24px;
                }
              }
            }
            tr:nth-child(even) {
              background-color: rgba(var(--cup-main-color-6-rgb), 0.1);
            }
          }
        }
      }
    }

    .quiz-container {
      margin: 40px 0 8px 0;
      background-color: var(--cup-general-color-2);
      border-radius: 8px;
      text-align: center;
      .quiz-heading {
        padding: 36px 12px 8px 12px;
        font-size: 36px;
        line-height: 44px;
        font-weight: 400;
        letter-spacing: -1px;
        @include media-breakpoint-down(sm) {
          padding: 16px 32px 0px 32px;
          font-size: 24px;
          line-height: 32px;
          letter-spacing: normal;
        }
      }
      .quiz-description {
        padding-top: 24px;
        padding-bottom: 8px;
        font-size: 20px;
        line-height: 30px;
        font-weight: 400;
        color: var(--cup-general-color-5);
        @include media-breakpoint-down(sm) {
          padding-top: 16px;
          font-size: 14px;
          line-height: 20px;
        }
      }
      .quiz-button {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 4px;
        width: 48%;
        margin: 20px auto 48px auto;
        background-color: var(--cup-general-color-1);
        border-radius: 24px;
        font-size: 14px;
        line-height: 16px;
        font-weight: 700;
        @include media-breakpoint-down(sm) {
          width: 60%;
          margin: 16px auto 32px auto;
        }
        cursor: pointer;
        .quiz-text {
          padding-left: 12px;
        }
        .quiz-right-icon {
          margin-top: 4px;
          font-size: 18px;
        }
      }
    }
  }
}
</style>
